import React from 'react';
import { TrStyle } from './style';

export default function LineTableMonth({
  title,
  firstLetter,
  secondLetter,
  firstLinkJan,
  secondLinkJan,
  firstLinkFev,
  secondLinkFev,
  firstLinkMar,
  secondLinkMar,
  firstLinkAbr,
  secondLinkAbr,
  firstLinkMai,
  secondLinkMai,
  firstLinkJun,
  secondLinkJun,
  firstLinkJul,
  secondLinkJul,
  firstLinkAgo,
  secondLinkAgo,
  firstLinkSet,
  secondLinkSet,
  firstLinkOut,
  secondLinkOut,
  firstLinkNov,
  secondLinkNov,
  firstLinkDez,
  secondLinkDez,
}) {
  return (
    <TrStyle>
      <td>{title}</td>
      <td>
        <a href={firstLinkJan}>{firstLetter}</a> <a href={secondLinkJan}>{secondLetter}</a>
      </td>
      <td>
        <a href={firstLinkFev}>{firstLetter}</a> <a href={secondLinkFev}>{secondLetter}</a>
      </td>
      <td>
        <a href={firstLinkMar}>{firstLetter}</a> <a href={secondLinkMar}>{secondLetter}</a>
      </td>
      <td>
        <a href={firstLinkAbr}>{firstLetter}</a> <a href={secondLinkAbr}>{secondLetter}</a>
      </td>
      <td>
        <a href={firstLinkMai}>{firstLetter}</a> <a href={secondLinkMai}>{secondLetter}</a>
      </td>
      <td>
        <a href={firstLinkJun}>{firstLetter}</a> <a href={secondLinkJun}>{secondLetter}</a>
      </td>
      <td>
        <a href={firstLinkJul}>{firstLetter}</a> <a href={secondLinkJul}>{secondLetter}</a>
      </td>
      <td>
        <a href={firstLinkAgo}>{firstLetter}</a> <a href={secondLinkAgo}>{secondLetter}</a>
      </td>
      <td>
        <a href={firstLinkSet}>{firstLetter}</a> <a href={secondLinkSet}>{secondLetter}</a>
      </td>
      <td>
        <a href={firstLinkOut}>{firstLetter}</a> <a href={secondLinkOut}>{secondLetter}</a>
      </td>
      <td>
        <a href={firstLinkNov}>{firstLetter}</a> <a href={secondLinkNov}>{secondLetter}</a>
      </td>
      <td>
        <a href={firstLinkDez}>{firstLetter}</a> <a href={secondLinkDez}>{secondLetter}</a>
      </td>
    </TrStyle>
  );
}
